<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<a id="page2"></a>
<p class="copy2"><span class="CharOverride-4">ISBN Number: </span><span class="CharOverride-4">978-1-63747-415-0</span></p>
<p class="copy"><span class="CharOverride-4">eBook ISBN Number:</span><span class="CharOverride-4">978-1-63747-416-7</span></p>
<p class="copy1"><span class="CharOverride-4">Library of Congress Number: 2024945518</span></p>
<p class="copy1"><span class="CharOverride-5">Copyright © 2024 </span><span class="CharOverride-5">Sharlene Frances</span><span class="CharOverride-5"><br/>—</span><span class="CharOverride-5">Second Edition</span><span class="CharOverride-5">—</span></p>
<p class="copy1"><span class="CharOverride-5">All rights reserved, including the right of reproduction in any form, or by any mechanical or electronic means including photocopying or recording, or by any information storage or retrieval system, in whole or in part in any form, and in any case not without the written permission of the author.</span></p>
<p class="copy2"><span class="CharOverride-5">Manufactured in the </span><span class="CharOverride-5">United States of America.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copy.vue?54472e07